import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage"; // eager — first paint matters
import CookieBanner from "./components/CookieBanner";

// Lazy-load every non-home page → each becomes its own JS chunk loaded on demand.
const LeistungenPage = lazy(() => import("./pages/LeistungenPage"));
const PreisePage = lazy(() => import("./pages/PreisePage"));
const UeberMichPage = lazy(() => import("./pages/UeberMichPage"));
const BlogPage = lazy(() => import("./pages/BlogPage"));
const BlogArticlePage = lazy(() => import("./pages/BlogArticlePage"));
const FaqPage = lazy(() => import("./pages/FaqPage"));
const KontaktPage = lazy(() => import("./pages/KontaktPage"));
const PortalLoginPage = lazy(() => import("./pages/PortalLoginPage"));
const PortalDashboardPage = lazy(() => import("./pages/PortalDashboardPage"));
const StatusPage = lazy(() => import("./pages/StatusPage"));
const SalonMarleneDemo = lazy(() => import("./pages/SalonMarleneDemo"));
const SchreinereiBrennerDemo = lazy(() => import("./pages/SchreinereiBrennerDemo"));
const PhysioSommerDemo = lazy(() => import("./pages/PhysioSommerDemo"));
const AdminPage = lazy(() => import("./pages/AdminPage"));
const DatenschutzPage = lazy(() => import("./pages/DatenschutzPage"));
const ImpressumPage = lazy(() => import("./pages/ImpressumPage"));

const PageFallback = () => (
  <div
    role="status"
    aria-label="Lädt"
    className="min-h-[60vh] flex items-center justify-center"
  >
    <div className="w-8 h-8 rounded-full border-2 border-zinc-200 border-t-zinc-900 animate-spin" />
  </div>
);

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <Suspense fallback={<PageFallback />}>
          <Routes>
            {/* Standalone (no shared Layout) */}
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/demo/salon-marlene" element={<SalonMarleneDemo />} />
            <Route path="/demo/schreinerei-brenner" element={<SchreinereiBrennerDemo />} />
            <Route path="/demo/physiotherapie-sommer" element={<PhysioSommerDemo />} />

            {/* Site pages with shared Navbar + Footer */}
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/leistungen" element={<LeistungenPage />} />
              <Route path="/preise" element={<PreisePage />} />
              <Route path="/ueber-mich" element={<UeberMichPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogArticlePage />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/kontakt" element={<KontaktPage />} />
              <Route path="/status" element={<StatusPage />} />
              <Route path="/portal" element={<PortalLoginPage />} />
              <Route path="/portal/dashboard" element={<PortalDashboardPage />} />
            </Route>
          </Routes>
        </Suspense>
        <CookieBanner />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
